"use strict";

import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { Component, createContext } from "react";
import { observer } from "mobx-react";
import { action, computed, observable } from "mobx";
import { randomString } from "../../../utils";
import { isNil } from "lodash";
import classNames from "classnames";
import { AnimationDuration } from "../../../styles/Animations";
var isControlledProps = function isControlledProps(props) {
  return !isNil(props.selectedIndex) && !isNil(props.onChange);
};
var isUncontrolledProps = function isUncontrolledProps(props) {
  return !isControlledProps(props);
};
export var TabsContext = createContext({});
var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);
  var _super = _createSuper(Tabs);
  function Tabs(props) {
    var _this;
    _classCallCheck(this, Tabs);
    var _a;
    _this = _super.call(this, props);
    _this.id = randomString();
    _this.tabRefs = [];
    _this.animating = false;
    _this.setSelectedIndex = function (index) {
      var _a, _b;
      _this.prevSelectedIndex = _this._selectedIndex;
      _this._selectedIndex = index;
      (_b = (_a = _this.props).onChange) == null ? void 0 : _b.call(_a, index);
      _this.setAnimating(true);
      if (_this.timeout) {
        clearTimeout(_this.timeout);
      }
      _this.timeout = setTimeout(function () {
        _this.setAnimating(false);
      }, AnimationDuration.Short);
    };
    _this.addTabRef = function (tabRef, index) {
      _this.tabRefs = [].concat(_toConsumableArray(_this.tabRefs.slice(0, index)), [tabRef], _toConsumableArray(_this.tabRefs.slice(index)));
    };
    _this.removeTabRef = function (tabRef) {
      var newTabRefs = _this.tabRefs.filter(function (ref) {
        return ref !== tabRef;
      });
      _this.tabRefs = newTabRefs;
    };
    _this.setPanelRef = function (panelRef) {
      _this.panelRef = panelRef;
    };
    _this.setIndicator = function (indicator) {
      _this.indicator = indicator;
    };
    _this.updatePanelHeight = function (height) {
      _this.panelHeight = height;
    };
    _this.setAnimating = function (animating) {
      _this.animating = animating;
    };
    _this.focusPanel = function () {
      var _a, _b;
      (_b = (_a = _this.panelRef) == null ? void 0 : _a.current) == null ? void 0 : _b.focus();
    };
    if (isControlledProps(props)) {
      _this._selectedIndex = props.selectedIndex;
    } else if (isUncontrolledProps(props)) {
      _this._selectedIndex = (_a = props.initialIndex) != null ? _a : 0;
    } else {
      _this._selectedIndex = 0;
    }
    return _this;
  }
  _createClass(Tabs, [{
    key: "selectedIndex",
    get: function get() {
      if (isControlledProps(this.props)) {
        return this.props.selectedIndex;
      }
      return this._selectedIndex;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (isControlledProps(this.props) && !isControlledProps(prevProps)) {
        console.error("Tabs component changed from uncontrolled to controlled component; this may cause unexpected behaviour.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /* @__PURE__ */React.createElement(TabsContext.Provider, {
        value: {
          selectedIndex: this.selectedIndex,
          setSelectedIndex: this.setSelectedIndex,
          prevSelectedIndex: this.prevSelectedIndex,
          tabRefs: this.tabRefs,
          focusPanel: this.focusPanel,
          addTabRef: this.addTabRef,
          removeTabRef: this.removeTabRef,
          setPanelRef: this.setPanelRef,
          panelHeight: this.panelHeight,
          id: this.id,
          updatePanelHeight: this.updatePanelHeight,
          indicator: this.indicator,
          setIndicator: this.setIndicator,
          animating: this.animating
        }
      }, /* @__PURE__ */React.createElement("div", {
        className: classNames("tabs", this.props.className, {
          "tabs--gapless": this.props.gapless === true
        })
      }, this.props.children));
    }
  }]);
  return Tabs;
}(Component);
__decorateClass([observable.ref], Tabs.prototype, "panelRef", 2);
__decorateClass([observable.ref], Tabs.prototype, "tabRefs", 2);
__decorateClass([observable.ref], Tabs.prototype, "prevSelectedIndex", 2);
__decorateClass([observable.ref], Tabs.prototype, "_selectedIndex", 2);
__decorateClass([observable.ref], Tabs.prototype, "panelHeight", 2);
__decorateClass([observable.ref], Tabs.prototype, "indicator", 2);
__decorateClass([observable.ref], Tabs.prototype, "animating", 2);
__decorateClass([action], Tabs.prototype, "setSelectedIndex", 2);
__decorateClass([action], Tabs.prototype, "addTabRef", 2);
__decorateClass([action], Tabs.prototype, "removeTabRef", 2);
__decorateClass([action], Tabs.prototype, "setPanelRef", 2);
__decorateClass([action], Tabs.prototype, "setIndicator", 2);
__decorateClass([action], Tabs.prototype, "updatePanelHeight", 2);
__decorateClass([action], Tabs.prototype, "setAnimating", 2);
__decorateClass([computed], Tabs.prototype, "selectedIndex", 1);
Tabs = __decorateClass([observer], Tabs);
export function withTabs(Component2) {
  return function WrapperComponent(props) {
    return /* @__PURE__ */React.createElement(TabsContext.Consumer, null, function (context) {
      return /* @__PURE__ */React.createElement(Component2, __spreadProps(__spreadValues({}, props), {
        tabs: context
      }));
    });
  };
}
export default Tabs;